import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";

export class UnrecognizedEmailResource extends BaseResource {
	id?: number;
	subject: string;
	from: string;
	body: string;

	pk() {
		return this.id?.toString();
	}

	static urlRoot = apiResourceUrl("unrecognized-email/{id}");
}
